if (!customElements.get('product-info-tabs')) {
  class ProductInfoTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
      });
    }

    activateTab(selectedTab) {
      const panelId = selectedTab.getAttribute('aria-controls');
      const selectedPanel = panelId ? document.getElementById(panelId) : null;

      this.tabs.forEach((tab) => {
        const isActive = tab === selectedTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isActive = panel === selectedPanel;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    handleKeydown(event, tab) {
      const currentIndex = this.tabs.indexOf(tab);
      let nextIndex = null;

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      }

      if (nextIndex === null) return;

      event.preventDefault();
      this.activateTab(this.tabs[nextIndex]);
      this.tabs[nextIndex].focus();
    }
  }

  customElements.define('product-info-tabs', ProductInfoTabs);
}
